<template>
    <div class="listContent">
        <a-form class="headForm" labelAlign="left">
            <a-row :gutter="24">
                <a-col :span="6">
                    <a-form-item label="成果编号">
                        <a-input v-model="resultCode"
                            @pressEnter="getList({ current: 1, pageSize: pagination.pageSize })"
                            placeholder="请输入成果编号" />
                    </a-form-item>
                </a-col>
                <a-col :span="6">
                    <a-form-item label="成果名称">
                        <a-input v-model="resultName"
                            @pressEnter="getList({ current: 1, pageSize: pagination.pageSize })"
                            placeholder="请输入成果名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="6">
                    <a-form-item label="线路">
                        <a-select show-search v-model="lineId" placeholder="选择线路" :filter-option="(input, option) => {
                            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }">
                            <a-select-option v-for="el in lineList" :key="el.id" :value="el.id">
                                {{ el.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="6">
                    <a-form-item label="成果分类">
                        <a-select show-search allowClear v-model="classification" placeholder="请选择分类" :filter-option="(input, option) => {
                            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }">
                            <a-select-option v-for="el in classList" :key="el.key" :value="el.key">
                                {{ el.text }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="10" class="submitBtnBox">
                    <a-button type="primary" class="btnMar"
                        @click="getList({ current: 1, pageSize: pagination.pageSize })">
                        查询
                    </a-button>
                    <a-button class="" @click="resetFields">
                        清空
                    </a-button>
                </a-col>
            </a-row>
        </a-form>

        <div class="content_class">
            <a-table ref="listRef" :scroll="{ y, x: 1000 }" class="tableBox" :columns="columns" :data-source="list"
                :pagination="pagination">

                <template slot="lineCode" slot-scope="text">
                    {{ lineMap[text] }}
                </template>
                <template slot="classification" slot-scope="text">
                    {{ classList.find(el => el.key === text).text }}
                </template>
                <template slot="option" slot-scope="text,record">
                    <a type="link" @click="viewRecord(record)" size="small">查看</a>
                </template>

            </a-table>
        </div>
    </div>
</template>
<script>
const columns = [
    {
        title: '成果编号',
        dataIndex: 'no',
    },
    {
        title: '成果名称',
        dataIndex: 'name',
    },
    {
        title: 'RMP线路',
        dataIndex: 'lineCode',
        scopedSlots: { customRender: 'lineCode' },
    },
    {
        title: '成果分类',
        dataIndex: 'classification',
        scopedSlots: { customRender: 'classification' },
    },
    {
        title: '发布日期',
        dataIndex: 'publishTime',
    },
    {
        title: '操作',
        dataIndex: 'option',
        scopedSlots: { customRender: 'option' }
    },
];
export default {
    data() {
        return {
            resultCode: '',
            resultName: '',
            lineId: '',
            classification: undefined,

            classList: [
                { key: 1, text: '研发成果类' },
                { key: 2, text: '技术方案总结类' },
                { key: 3, text: '新品种培育类' }
            ],
            lineList: [],
            lineMap: {
                '31': '禽料线路',
                '32': '反刍线路',
                '33': '水产料线路',
                '34': '猪料线路'
            },
            y: 500,
            columns,
            pagination: {
                total: 0,
                pageSize: 20,
                current: 1,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showSizeChanger: true,
                showTotal: (total) => `共${total}条记录`,
                onChange: (current, pageSize) => {
                    this.pagination.current = current;
                    this.pagination.pageSize = pageSize;
                    this.getList();
                },//选择页数
                onShowSizeChange: (current, pageSize) => {
                    this.pagination.pageSize = pageSize;
                    this.pagination.current = 1;
                    this.getList({ current: 1, pageSize });
                } //每页多少条
            },
            list: []
        };
    },
    created() {
        this.getLineList();
    },
    mounted() {
        this.y = this.$refs.listRef.$el.offsetHeight - 116;
    },
    methods: {
        getLineList() {
            const factoryId = window.localStorage.getItem('factoryId');
            this.$http.get('/iot-factory/FactoryAnimal/listByParentId?parentId=1386959577212751874&factoryId=' + factoryId, {}).then(res => {
                let { success, data } = res;
                if (success) {
                    this.lineList = data || [];
                    if (data.length > 0)
                        this.lineId = data[0].id;
                    this.getList();
                } else {
                    this.$message.error('查询失败');
                }
            });
        },
        getList(pagination) {
            let { current, pageSize } = pagination || this.pagination;
            let params = {
                query: {
                    current,
                    size: pageSize,
                },
                no: this.resultCode,
                name: this.resultName,
                animalTypeCode: this.lineId,
                classification: this.classification
            };
            this.$http.post('/nhf-app/formularmpresult/pageRmpResultVO', params).then(res => {
                let { success, data } = res;
                if (success) {
                    let { records, current = 1, total = 0 } = data;
                    this.pagination.current = current;
                    this.pagination.total = total;
                    this.list = records || [];
                } else {
                    this.$message.error('查询失败');
                }
            });
        },
        resetFields() {
            this.resultCode = '';
            this.resultName = '';
            this.classification = undefined;

            this.getList({ current: 1, pageSize: this.pagination.pageSize });
        },
        viewRecord(item) {
            item.lineText = this.lineMap[item.lineCode];
            item.classificationText = this.classList[item.classification - 1].text;
            window.localStorage.setItem('rmpResult', JSON.stringify(item));
            this.$router.push({
                path: '/rmp/rd-result/rd-result-detail',
                query: {
                    id: item.id,
                    name: '研发成果查看'
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.listContent {
    height: calc(100% - 41px);
    border-radius: 5px;

    .title_class {
        background-color: #fff;
        margin-bottom: 21px;
        border-radius: 5px;
        padding: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .title_search_class {
            display: flex;
            flex-wrap: wrap;
            flex: 2;

            .search_change_class {
                display: flex;
                align-items: center;
                margin: 0 10px 10px 0;

                .text_class {
                    width: 100px;
                }
            }
        }

        .title_btn_class {
            flex: 0.6;

            .search_class {
                margin-right: 10px;
            }
        }
    }

    .content_class {
        background-color: #fff;
        border-radius: 5px;
        height: calc(100% - 80px);
    }
}

.tableBox {
    height: 100%;
}
</style>
